var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewSpam = function SvgNewSpam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.536 20.668h6.503a.887.887 0 0 0 .773-.893l.7-7.7H7.059l.7 7.7a.887.887 0 0 0 .777.893M10.497 14.652v3.008M13.075 14.652v3.008M7.003 8.965l-1.9-1.185a.575.575 0 0 1-.184-.794l3.356-5.382a.577.577 0 0 1 .794-.184L16.897 6.3a.576.576 0 0 1 .184.795L15.65 9.39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.624 1.35 10.25 6.8a1.154 1.154 0 0 0 1.295.807l5.61-.937"
  })));
};
export default SvgNewSpam;